import AxiosConfig from '@/config/axios-config'

export const EmentaAPI = {

  listar (pagina, filtro) {
    return AxiosConfig.jalekoAPI().get('/admin/ementas',
      {
        params: {
          page: pagina,
          curso_id: filtro.curso,
          modulo_id: filtro.modulo,
          licao_id: filtro.licao
        }
      }).then(response => response.data)
  },

  associarQuestoes (ementa) {
    return AxiosConfig.secureJalekoAPI().post('/admin/ementas/associar-questoes', ementa).then(response => response.data)
  },

  associarTextos (ementa) {
    return AxiosConfig.secureJalekoAPI().post('/admin/ementas/associar-textos', ementa).then(response => response.data)
  },

  associarVideos (ementa) {
    return AxiosConfig.secureJalekoAPI().post('/admin/ementas/associar-videos', ementa).then(response => response.data)
  },

  associarImagens (ementa) {
    return AxiosConfig.secureJalekoAPI().post('/admin/ementas/associar-imagens', ementa).then(response => response.data)
  },

  associarPdfsTopico (ementa) {
    return AxiosConfig.secureJalekoAPI().post('/admin/ementas/associar-pdfs-topico', ementa).then(response => response.data)
  },

  associarPdfsResumo (ementa) {
    return AxiosConfig.secureJalekoAPI().post('/admin/ementas/associar-pdfs-resumo', ementa).then(response => response.data)
  },

  salvar (ementa) {
    return AxiosConfig.secureJalekoAPI().post('/admin/ementas', ementa).then(response => response.data)
  },

  editar (ementa) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/ementas/${ementa.id}`, ementa).then(response => response.data)
  },

  deletar (ementa, cursoId, moduloId, licaoId) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/ementas/${ementa.id}`,
      {
        params: {
          curso_id: cursoId,
          modulo_id: moduloId,
          licao_id: licaoId
        }
      }).then(response => response.data)
  }

}

export default EmentaAPI
